var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowupicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64316 16.7106L5.62924 16.7229L5.61446 16.7341C5.09378 17.1282 4.35414 17.0837 3.88402 16.6041C3.37199 16.0818 3.37199 15.2391 3.88402 14.7168L11.061 7.39587L11.0738 7.38278L11.0876 7.37066L11.1799 7.28937L11.1938 7.27711L11.2086 7.26593C11.7293 6.87184 12.4689 6.91632 12.939 7.39587L20.116 14.7168L20.1288 14.7298L20.1406 14.7438L20.2203 14.838L20.2322 14.852L20.243 14.8668C20.623 15.3892 20.5823 16.1284 20.116 16.6041L20.1031 16.6172L20.0894 16.6293L19.9971 16.7106L19.9832 16.7229L19.9684 16.7341C19.4477 17.1282 18.7081 17.0837 18.2379 16.6041L18.2379 16.6041L12 10.2408L5.76208 16.6041L5.74924 16.6172L5.73547 16.6293L5.64316 16.7106Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowupicon);
export default __webpack_public_path__ + "static/media/arrowup.icon.5746bfd724e03090649f850e1b581f00.svg";
export { ForwardRef as ReactComponent };